import * as React from "react";
import { Helmet } from "react-helmet";

// Presentation/UI
import MainBanner from "./MainBanner";
import Features from "./Features";
import SupervisorsAndTechnicians from "./SupervisorsAndTechnicians";
import Clients from "./Clients";
import CallToAction from "./CallToAction";
import Footer from "./Footer";

class Home extends React.Component<{}> {
  render() {
    return (
      <div>
        <MainBanner />
        <Features />
        <SupervisorsAndTechnicians />
        <Clients />
        <CallToAction />
        <Footer />
        <Helmet title="Maintenance Management, Made Easy" />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Containers/Home/index.tsx